import type { ReactNode } from 'react';
import { Label } from '@tempmee/react';

export interface IEdtBadgeProps {
  /** Timezone label. Defaults to 'EDT'; detail rows pass the shift's real timezone. */
  children?: ReactNode;
}

/**
 * Small timezone pill shown beside an "Hours:" row. A shared atom rather than a
 * per-screen re-declaration — it is rendered across the shift-request, confirm,
 * job-details and receipt flows and must not drift between them.
 *
 * Built on the design-system `Label` ("a small uppercase status chip"), which is
 * what this row has always been. The previous hand-rolled version pinned
 * `height: 15` around a 15.6px line box, so the text overflowed its own container
 * and sat flush against the top and bottom edges while keeping 6px at the sides.
 * `Label` sizes to its content with symmetric padding, so the crowding goes away.
 */
export const EdtBadge = ({ children = 'EDT' }: IEdtBadgeProps) => (
  <Label severity="brand" variant="standard">
    {children}
  </Label>
);
